import "bootstrap/dist/css/bootstrap.min.css";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import "./LikedClubs.css";
import LoadingSpinner from "../../components/LoadingSpinner";
import { Star, StarFill, StarHalf } from "react-bootstrap-icons";

export default function LikedClubs() {
  const { user,dispatch } = useAuthContext();
  const [clubtags, setClubTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navi = useNavigate();

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const clubTagsResponse = await axios.get(
        `${ApiConnectionString}/api/ClubTags`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      setClubTags(clubTagsResponse.data);
    } catch (error) {
      
  if (error.status == 401) {
    dispatch({ type: "LOGOUT" });
    navi("/");
  }
      console.error("Error fetching club tags:", error);
      // Handle the error, e.g., show a notification or update the UI accordingly
    } finally {
      setIsLoading(false); // Stop loading regardless of success or error
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="container">
        <div className="blueBanner">
          <p className="fw-bold p-2">Favourite Clubs</p>
        </div>
        {clubtags.length == 0 && (
          <div className="noFaves text-center bg-white mt-0">
            <p className="pt-3">
              Currently you have no favourite clubs. If you like a club and wish
              to add it to your favourites, press the heart icon at the top of
              the club page.
            </p>

            <p>You can browse clubs in the search clubs page.</p>

            <button onClick={() => navi("/searchClubs")} className="saveChanges-button">Search Clubs</button>
          </div>
        )}

        <div className="row">
          {clubtags.map((club) => {
            const { starsAverage = 0, starsCount = 0 } = club.viewClub; // Default to 0 if undefined
            const fullStars = Math.floor(starsAverage);
            const hasHalfStar = starsAverage % 1 !== 0; // Check if there's a half star
            const totalReviews = starsCount;

            return (
              <div
                key={club.id}
                onClick={() => navi(`/club/${club.viewClub.id}`)}
                className="search-club-container mx-2 my-3 d-flex flex-column justify-content-between"
              >
                <div>
                  <div className="d-flex justify-content-center">
                    <div className="search-circle-crop mt-3">
                      <img
                        src={
                          club.viewClub.image
                            ? `${ApiConnectionString}/api/ClubProfileImage/${club.viewClub.id}`
                            : NoImagePlaceholder
                        }
                        alt="Club Image"
                      />
                    </div>
                  </div>
                  <div className="text-center">
                    <p className="fontSize20 mt-2 mb-0 fw-bold">
                      {club.viewClub.name}
                    </p>
                    <p className="fw-bold mb-0">
                      {club.viewClub.city}, {club.viewClub.county}
                    </p>
            
                    <div className="d-flex justify-content-center">
                      <hr className="w-25" />
                    </div>
                    <p className="mb-0">
                      {club.viewClub.subtitle.substring(0, 120)}
                    </p>
                    <div className="d-flex justify-content-center">
                      <hr className="w-25" />
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center pointer mt-auto">
                  {[...Array(5)].map((_, index) => {
                    if (index < fullStars) {
                      return <StarFill key={index} />;
                    } else if (index === fullStars && hasHalfStar) {
                      return <StarHalf key={index} />;
                    } else {
                      return <Star key={index} />;
                    }
                  })}
                  <p className="mx-2 mt-4">
                    {starsAverage.toFixed(1)} • {totalReviews} reviews
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
